import { render, staticRenderFns } from "./IconSubtract.vue?vue&type=template&id=353d91fc&"
import script from "./IconSubtract.vue?vue&type=script&lang=js&"
export * from "./IconSubtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports